<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-index="index" let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps && instruction.lubricatedEye !== null) {
		<app-instruction-box>{{ instruction.lubricatedEye | lubricatedEyeName }}</app-instruction-box>
	}
</ng-template>